<template>
    <div class="detect">
        <div class="buy-btn">
            <a-button icon="plus-circle" type="primary" @click="buyDetect">购买次数包</a-button>
        </div>
        <a-row :gutter="15">
            <a-col span="8">
                <a-card>
                    <a-statistic title="购买总量" :value="withUnit(user.detect.total)"/>
                </a-card>
            </a-col>
            <a-col span="8">
                <a-card>
                    <a-statistic title="已使用额" :value="withUnit(user.detect.used)"/>
                </a-card>
            </a-col>
            <a-col span="8">
                <a-card>
                    <a-statistic title="剩余可用" :value="withUnit(user.detect.total-user.detect.used)"/>
                </a-card>
            </a-col>
        </a-row>
        <a-table
            style="margin-top:20px;" rowKey="id"
            :data-source="result.data" :columns="columns" :loading="loading" bordered>
        </a-table>
        <BuyDetect ref="buyDetect" :user="user"/>
    </div>
</template>

<script>
    import api from "../../../utils/api";
    import func from "../../../utils/func";
    import DelayLoading from "../../../comps/DelayLoading";
    import BuyDetect from "./comps/BuyDetect";

    export default {
        name: "Detect",
        components: {BuyDetect},
        props: {user: Object},
        mixins: [DelayLoading],
        data() {
            return {
                params: {
                    page_no: 1,
                    page_size: 15
                },
                result: {
                    total: 0,
                    data: []
                },
                columns: [
                    {title: "购买次数", dataIndex: "count"},
                    {title: "备注说明", dataIndex: "comment"},
                    {
                        title: "购买时间", dataIndex: "created_at",
                        width: 160, customRender: (v) => func.tsFormat(v)
                    }
                ]
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {
                const self = this;
                this.withLoading(300, () => {
                    return api.v1.user.detect.search(this.params)
                        .then(res => self.result = res);
                });
            },
            withUnit(value) {
                return `${value} 次`
            },
            buyDetect() {
                this.$refs.buyDetect.open();
            }
        }
    }
</script>


<style lang="less">
    .detect {
        .buy-btn {
            text-align: right;
            margin-top: -70px;
            margin-bottom: 40px;
        }
    }
</style>
